export default __webpack_public_path__ + "static/media/worker9.100116c1.jpeg";